import React from 'react';

import jssPreset from '@mui/styles/jssPreset';
import StylesProvider from '@mui/styles/StylesProvider';
import { create } from 'jss';
import jssextend from 'jss-plugin-extend';

const jss = create({
  plugins: [...jssPreset().plugins, jssextend()],
});

export default function ({ children }) {
  return <StylesProvider jss={jss}>{children}</StylesProvider>;
}
